<template>
  <div class="other-tooltip">
    <span
      :ref="`${colKey}${index}`"
      class="opacity0"
      :style="{fontSize: fieldtype === 'datetime' ? '12px' : '14px'}"
    >{{ fieldtype === 'datetime' ? $moment(new Date(text)).format('YYYY-MM-DD') : text }}</span>
    <a-tooltip
      :visible.sync="visible"
      overlay-class-name="td-tooltip"
      @visibleChange="visibleChange"
    >
      <span slot="title">
        {{ text }}
      </span>

      <div
        v-if="fieldtype === 'datetime' && text !== '- -'"
        class="date_time"
      >
        <p class="date">
          {{ text && text.split(' ') && text.split(' ')[0] }}
        </p>
        <p class="time fs-gray">
          {{ text && text.split(' ') && text.split(' ')[1] }}
        </p>
      </div>
      <template v-else>
        {{ text || '- -' }}
      </template>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    colKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    fieldtype () {
      let item = this.columns.find(item => item.key === this.colKey) || {}
      let fieldtype = item.fieldtype
      if (this.colKey === 'next_followup_time') {
        fieldtype = 'datetime'
      }
      return fieldtype
    }
  },
  methods: {
    visibleChange (show) {
      let $ele = this.$refs[`${this.colKey}${this.index}`]
      let contentWidth = $ele && $ele.clientWidth
      // let contentWidth = $ele && $ele.getBoundingClientRect().width
      let item = this.columns.find(item => item.key === this.colKey) || {}
      let tdWidth = item.width - 32 || 0

      if (show) {
        // console.log(tdWidth, contentWidth)
        if (tdWidth && contentWidth && tdWidth < contentWidth) {
          this.visible = true
        } else {
          this.visible = false
        }
      } else {
        this.visible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .other-tooltip {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .opacity0 {
      opacity: 0;
      position: absolute ;
      z-index: -1;
    }
    .date_time {
      font-size: 12px;
      position: absolute;
      top: 8px;
      line-height: 18px;
    }
  }
</style>
